export default __webpack_public_path__ + "static/lamudi-white-4c112131a28f0dcc7171938b838515a7.png";